import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-navy px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-89" data-mp="28u4ncn43lelf">
      <p className="font-heading text-[15px] font-extrabold uppercase tracking-[0.06em] text-aqua md:text-[18px]" data-id="element-90" data-mp="28vzbsbekvou9">
        Complete AAC Communication Toolkit™
      </p>
      <h1 className="mt-1 font-heading text-[25px] font-extrabold uppercase leading-[1.08] tracking-[-0.3px] text-white md:text-[34px]" data-id="element-91" data-mp="30ksr86x5oy2s">
        The complete advanced <span className="text-aqua" data-id="element-92" data-mp="2rsgygeekkyjn">AAC intervention system</span> for Speech-Language Pathologists
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-93" data-mp="3fiba4sn5kh2b">
        Stop building AAC materials from scratch. Get advanced functional, language, self-advocacy, access,
        participation, and clinical case resources — organized into one professional collection.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] font-heading text-[13px] font-extrabold uppercase leading-tight text-gold md:text-[15px]" data-id="element-94" data-mp="2bf84sdm4eb9l">
        Less preparation. More time for intervention.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-95" data-mp="2kd20pnfz32w8">
        <ProductImage data-id="element-96" data-mp="2z3991ac9n5j7" />
      </div>

      <p className="mx-auto mt-2 max-w-[520px] font-heading text-[13px] font-bold uppercase leading-snug text-white md:text-[15px]" data-id="element-97" data-mp="2z26jp6uldb5e">
        6 Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-1 font-heading text-[13px] font-extrabold uppercase leading-tight text-aqua md:text-[15px]" data-id="element-98" data-mp="3834p9tkohqq3">
        390 Pages of Advanced Clinical Resources
      </p>

      <div className="mt-3.5" data-id="element-99" data-mp="1dpwu20ssjd3x">
        <CtaButton mode="scroll" data-id="element-100" data-mp="1dqy1lvallhgw">Yes! I want my complete AAC toolkit!</CtaButton>
      </div>
      <p className="mt-3 font-heading text-[11px] font-bold uppercase tracking-[0.12em] text-white md:text-[12px]" data-id="element-101" data-mp="18s4ymwsxt8uz">
        Get your professional AAC resources today.
      </p>
      <p className="mx-auto mt-1 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-102" data-mp="3drw8llbwwg9s">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-103" data-mp="3mt48g7u2tp5z" />
            7-day money-back guarantee •{' '}
          </>}
        6 volumes + 5 free bonuses
      </p>
    </header>;
}